<script setup lang="ts">
import { PropType } from 'vue'
import Product from '~/models/Product/Product'

const props = defineProps({
    product: {
        type: Object as PropType<Product>,
        required: true,
    },
    dynamicBundles: {
        type: Boolean,
        default: false,
    },
    hasVariants: {
        type: Boolean,
        default: false,
    },
})

const visible = ref(false)

const openDeliveryModal = () => {
    visible.value = true
    if (!props.product.availabilityModalEnabled || props.dynamicBundles) {
        return
    }

    setTimeout(() => {
        useNuxtApp().$bus.$emit('showDeliveryModal', props.product.id)
    }, 0)
}
</script>

<template>
    <span
        v-if="!hasVariants"
        class="product__availability"
        data-cy="product-availibility"
        :class="[
            { 'product__availability--green': product.amountInStock && product.isAvailable },
            product.availabilityModalEnabled && 'product__availability__clickable',
        ]"
        @click.stop="openDeliveryModal"
        v-html="product.availabilityText || '&nbsp;'"
    ></span>
    <span v-else class="product__availability">&nbsp;</span>
</template>

<style scoped lang="scss">
.product {
    &__availability {
        font-size: 13px;
        padding: 3px 0 5px 0;
        font-weight: 300;
        color: $color-orange-dark;
        display: block;

        &--green {
            color: #567746;
            font-weight: 600;
        }

        @include screen-md {
            font-size: 14px;
        }

        &__clickable {
            cursor: help;
        }
    }
}
</style>
